export default [    
    {   name:'MarketingPlans',
        route:'/MarketingPlans'
    },
    {   name:'MarketingPlanTemplates',
        route:'/MarketingPlanTemplates'
    },
    {   name:'ReportMarketingMarketingPlansReport',
        route:'/Reports/Marketing/MarketingPlans'
    },
    {   name:'ClientMarketingPlans',
        route:'/Clients/:clientId/MarketingPlans'
    },
    {   name:'ClientMarketingPlanTemplates',
        route:'/Clients/:clientId/MarketingPlanTemplates',
    },
    {   
        name:'ClientsReportMarketingMarketingPlansReport',
        route:'/Clients/:clientId/Reports/Marketing/MarketingPlans',
    }   
];